import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "my-4",
  style: {"width":"200px"}
}
const _hoisted_2 = {
  key: 0,
  class: "py-2"
}
const _hoisted_3 = {
  key: 1,
  class: "my-2"
}
const _hoisted_4 = { class: "children-table" }
const _hoisted_5 = { class: "children-table__headers" }
const _hoisted_6 = { class: "children-table__header col-month" }
const _hoisted_7 = { class: "children-table__header col-height" }
const _hoisted_8 = { class: "children-table__header col-weight" }
const _hoisted_9 = { class: "children-table__header col-other" }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_child_growth_record_row = _resolveComponent("child-growth-record-row")!
  const _component_g_chart = _resolveComponent("g-chart")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_breadcrumbs, {
        class: "px-0",
        items: [
          { title: 'Growth Record List', href: '/growth-record', color: 'primary' },
          { title: `${_ctx.childName}'s Growth Record` },
        ]
      }, null, 8, ["items"])
    ]),
    _createVNode(_component_page_title, {
      value: _ctx.$t('growthRecord.childRecordTitle', { name: _ctx.childName })
    }, null, 8, ["value"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_text_field, {
        variant: "outlined",
        density: "compact",
        modelValue: _ctx.year,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.year) = $event)),
        modelModifiers: { number: true },
        suffix: _ctx.$t('growthRecord.fiscalYearSuffix'),
        type: "number"
      }, null, 8, ["modelValue", "suffix"])
    ]),
    (_ctx.recordRequests.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "flat",
            disabled: _ctx.isSaving,
            onClick: _ctx.saveRecords
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isSaving)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_v_progress_linear, {
            indeterminate: "",
            color: "primary"
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('growthRecord.monthLabel')), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('growthRecord.heightCm')), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('growthRecord.weightKg')), 1),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('growthRecord.remarks')), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recordsWithMonth, (r) => {
        return (_openBlock(), _createBlock(_component_child_growth_record_row, {
          key: r.month,
          record: r.record,
          month: r.month,
          onInputHeight: ($event: any) => (_ctx.inputHeight($event, r)),
          onInputWeight: ($event: any) => (_ctx.inputWeight($event, r)),
          onInputRemarks: ($event: any) => (_ctx.inputRemarks($event, r))
        }, null, 8, ["record", "month", "onInputHeight", "onInputWeight", "onInputRemarks"]))
      }), 128))
    ]),
    (_ctx.growthRecord && _ctx.growthRecord.records.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", null, [
            _createVNode(_component_g_chart, {
              type: "ComboChart",
              data: _ctx.heightChartData,
              options: {
            colors:['transparent', _ctx.colorChartArea, _ctx.colorPrimary],
            seriesType: 'area',
            isStacked: true,
            series: {
              0: { lineWidth: 0, enableInteractivity: false, visibleInLegend: false },
              1: { lineWidth: 0, enableInteractivity: false, labelInLegend: _ctx.$t('growthRecord.percentileRangeLegend') },
              2: { lineWidth: 2, pointSize: 6, type: 'line' },
            },
            height: 700
          }
            }, null, 8, ["data", "options"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_g_chart, {
              type: "ComboChart",
              data: _ctx.weightChartData,
              options: {
            colors:['transparent', _ctx.colorChartArea, _ctx.colorPrimary],
            seriesType: 'area',
            isStacked: true,
            series: {
              0: { lineWidth: 0, enableInteractivity: false, visibleInLegend: false },
              1: { lineWidth: 0, enableInteractivity: false, labelInLegend: _ctx.$t('growthRecord.percentileRangeLegend') },
              2: { lineWidth: 2, pointSize: 6, type: 'line' },
            },
            height: 700
          }
            }, null, 8, ["data", "options"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_v_card, {
            variant: "outlined",
            class: "no-chart-card"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('growthRecord.graphsHint')), 1)
            ]),
            _: 1
          })
        ]))
  ]))
}